const initialLookup = {
  subscriberIdsLoading: false,
  subscriberIdsError: null,
  subscriberIds: null,
  linkedDevicesLoading: false,
  linkedDevicesError: null,
  linkedDevices: null,
};

const initialState = {
  search: { loading: false, error: null, data: null },
  lookup: { ...initialLookup },
  profile: { loading: false, error: null, data: null },
  devicePanel: { loading: false, error: null, data: null },
  entitlement: { loading: false, error: null, data: null },
  mixpanel: { loading: false, error: null, data: null },
  mixpanelEvents: { loading: false, error: null, data: null },
};

export const LIT_SUBSCRIBER_SEARCH_REQUEST = "LIT_SUBSCRIBER_SEARCH_REQUEST";
export const LIT_SUBSCRIBER_SEARCH_SUCCESS = "LIT_SUBSCRIBER_SEARCH_SUCCESS";
export const LIT_SUBSCRIBER_SEARCH_FAILURE = "LIT_SUBSCRIBER_SEARCH_FAILURE";

export const LIT_SUBSCRIBER_PROFILE_REQUEST = "LIT_SUBSCRIBER_PROFILE_REQUEST";
export const LIT_SUBSCRIBER_PROFILE_SUCCESS = "LIT_SUBSCRIBER_PROFILE_SUCCESS";
export const LIT_SUBSCRIBER_PROFILE_FAILURE = "LIT_SUBSCRIBER_PROFILE_FAILURE";

export const LIT_ENTITLEMENT_REQUEST = "LIT_ENTITLEMENT_REQUEST";
export const LIT_ENTITLEMENT_SUCCESS = "LIT_ENTITLEMENT_SUCCESS";
export const LIT_ENTITLEMENT_FAILURE = "LIT_ENTITLEMENT_FAILURE";

export const LIT_MIXPANEL_REQUEST = "LIT_MIXPANEL_REQUEST";
export const LIT_MIXPANEL_SUCCESS = "LIT_MIXPANEL_SUCCESS";
export const LIT_MIXPANEL_FAILURE = "LIT_MIXPANEL_FAILURE";

export const LIT_MIXPANEL_EVENTS_REQUEST = "LIT_MIXPANEL_EVENTS_REQUEST";
export const LIT_MIXPANEL_EVENTS_SUCCESS = "LIT_MIXPANEL_EVENTS_SUCCESS";
export const LIT_MIXPANEL_EVENTS_FAILURE = "LIT_MIXPANEL_EVENTS_FAILURE";

export const LIT_SUBSCRIBER_IDS_REQUEST = "LIT_SUBSCRIBER_IDS_REQUEST";
export const LIT_SUBSCRIBER_IDS_SUCCESS = "LIT_SUBSCRIBER_IDS_SUCCESS";
export const LIT_SUBSCRIBER_IDS_FAILURE = "LIT_SUBSCRIBER_IDS_FAILURE";

export const LIT_LINKED_DEVICES_REQUEST = "LIT_LINKED_DEVICES_REQUEST";
export const LIT_LINKED_DEVICES_SUCCESS = "LIT_LINKED_DEVICES_SUCCESS";
export const LIT_LINKED_DEVICES_FAILURE = "LIT_LINKED_DEVICES_FAILURE";

export const LIT_SUBSCRIBER_LOOKUP_RESET = "LIT_SUBSCRIBER_LOOKUP_RESET";

export const LIT_DEVICE_PANEL_REQUEST = "LIT_DEVICE_PANEL_REQUEST";
export const LIT_DEVICE_PANEL_SUCCESS = "LIT_DEVICE_PANEL_SUCCESS";
export const LIT_DEVICE_PANEL_FAILURE = "LIT_DEVICE_PANEL_FAILURE";

const litSubscriberReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIT_SUBSCRIBER_LOOKUP_RESET:
      return { ...state, lookup: { ...initialLookup } };

    case LIT_SUBSCRIBER_IDS_REQUEST:
      return {
        ...state,
        lookup: {
          ...initialLookup,
          subscriberIdsLoading: true,
        },
      };
    case LIT_SUBSCRIBER_IDS_SUCCESS:
      return {
        ...state,
        lookup: {
          ...state.lookup,
          subscriberIdsLoading: false,
          subscriberIdsError: null,
          subscriberIds: action.payload.subscriberIds || [],
          linkedDevices: null,
          linkedDevicesError: null,
        },
      };
    case LIT_SUBSCRIBER_IDS_FAILURE:
      return {
        ...state,
        lookup: {
          ...initialLookup,
          subscriberIdsLoading: false,
          subscriberIdsError: action.payload,
        },
      };

    case LIT_LINKED_DEVICES_REQUEST:
      return {
        ...state,
        lookup: {
          ...state.lookup,
          linkedDevicesLoading: true,
          linkedDevicesError: null,
          linkedDevices: null,
        },
      };
    case LIT_LINKED_DEVICES_SUCCESS:
      return {
        ...state,
        lookup: {
          ...state.lookup,
          linkedDevicesLoading: false,
          linkedDevicesError: null,
          linkedDevices: action.payload.devices || [],
        },
      };
    case LIT_LINKED_DEVICES_FAILURE:
      return {
        ...state,
        lookup: {
          ...state.lookup,
          linkedDevicesLoading: false,
          linkedDevicesError: action.payload,
          linkedDevices: null,
        },
      };

    case LIT_SUBSCRIBER_SEARCH_REQUEST:
      return { ...state, search: { loading: true, error: null, data: null } };
    case LIT_SUBSCRIBER_SEARCH_SUCCESS:
      return { ...state, search: { loading: false, error: null, data: action.payload } };
    case LIT_SUBSCRIBER_SEARCH_FAILURE:
      return { ...state, search: { loading: false, error: action.payload, data: null } };

    case LIT_SUBSCRIBER_PROFILE_REQUEST:
      return { ...state, profile: { loading: true, error: null, data: null } };
    case LIT_SUBSCRIBER_PROFILE_SUCCESS:
      return { ...state, profile: { loading: false, error: null, data: action.payload } };
    case LIT_SUBSCRIBER_PROFILE_FAILURE:
      return { ...state, profile: { loading: false, error: action.payload, data: null } };

    case LIT_DEVICE_PANEL_REQUEST:
      return { ...state, devicePanel: { loading: true, error: null, data: null } };
    case LIT_DEVICE_PANEL_SUCCESS:
      return { ...state, devicePanel: { loading: false, error: null, data: action.payload } };
    case LIT_DEVICE_PANEL_FAILURE:
      return { ...state, devicePanel: { loading: false, error: action.payload, data: null } };

    case LIT_ENTITLEMENT_REQUEST:
      return { ...state, entitlement: { loading: true, error: null, data: null } };
    case LIT_ENTITLEMENT_SUCCESS:
      return { ...state, entitlement: { loading: false, error: null, data: action.payload } };
    case LIT_ENTITLEMENT_FAILURE:
      return { ...state, entitlement: { loading: false, error: action.payload, data: null } };

    case LIT_MIXPANEL_REQUEST:
      return { ...state, mixpanel: { loading: true, error: null, data: null } };
    case LIT_MIXPANEL_SUCCESS:
      return { ...state, mixpanel: { loading: false, error: null, data: action.payload } };
    case LIT_MIXPANEL_FAILURE:
      return { ...state, mixpanel: { loading: false, error: action.payload, data: null } };

    case LIT_MIXPANEL_EVENTS_REQUEST:
      return {
        ...state,
        mixpanelEvents: { ...state.mixpanelEvents, loading: true, error: null },
      };
    case LIT_MIXPANEL_EVENTS_SUCCESS:
      return { ...state, mixpanelEvents: { loading: false, error: null, data: action.payload } };
    case LIT_MIXPANEL_EVENTS_FAILURE:
      return {
        ...state,
        mixpanelEvents: { ...state.mixpanelEvents, loading: false, error: action.payload },
      };

    default:
      return state;
  }
};

export default litSubscriberReducer;
